<button
    [ngStyle]="dynamicStyles()"
    [disabled]="btnLoading"
    [class.loading]="btnLoading"
    (click)="buttonClicked()"
    (keyup.enter)="buttonClicked()"
    [disabled]="isDisabled"
>
    <i *ngIf="btnProperties.icon && !btnLoading" [class]="btnProperties.icon" [style]="{'font-size': btnProperties.fontSize}"></i>
    <div *ngIf="!btnLoading" class="button-content">{{(btnProperties ? btnProperties.btnName : '') | driveLabelPipe}}</div>
    <div *ngIf="btnLoading" class="button-content loading-content">Loading...</div>
    <span *ngIf="count && count > 0" class="button-badge">{{ count }}</span>
</button>